
import React from 'react';
import HomeLP from '../components/HomeLP';
import PreloadResources from '../components/PreloadResources';

const Index = () => {
  return (
    <>
      <PreloadResources lcpImagePath="/lovable-uploads/e4b1575d-1cfa-44be-a5dc-60500d1054b7.png" />
      <HomeLP />
    </>
  );
};

export default Index;

